import Circuit from 'src/models/circuit/Circuit'
import Model, { ID, MODEL_LEVEL } from 'src/models/model'
import Site from 'src/models/site/Site'
export default class SiteLocationZone extends Model {
  static name = 'SiteLocationZone'
  static isConfiguration = true

  static versioned = true

  static level = MODEL_LEVEL.CIRCUIT

  static employeeRequiredPermissionCategories = [Model.permissionCategories.Circuit]

  static define () {
    this.fields = {
      id: {
        type: ID
      },
      circuit: {
        type: Circuit,
        reference: true,
        default: null
      },
      name: {
        type: String
      },
      displayOrder: {
        type: Number,
        default: 999
      },
      sites: {
        type: [Site],
        reference: true,
        encode (data) {
          data.siteLocationZoneIds = _.map(this.sites.data, 'id')
        },
        default: () => ([])
      }
    }

    this.computed = {
      visibleSites () {
        return _.filter(this.sites.data, site => !site.consumerConfig.hideOnLocationSelectPage)
      }
    }
  }
}
